

  import Vue from 'vue';

  import navbar from '@/components/navbar.vue';
  import { mdbCardImage, mdbCardText, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbContainer, mdbCard, mdbBtn, mdbRow, mdbCol, mdbCardUp, mdbCardAvatar, mdbCardBody, mdbCardTitle, mdbIcon, mdbInput, mdbTbl, mdbTblBody, mdbTblHead } from 'mdbvue';
  import router from '../router';

  import store from '../store';

  export default Vue.extend({
    name: 'Cities',
    data: function() {
      return {
        cities: store.state.cities, 
        chosenCity: undefined,
        weatherChosenCity: store.state.weatherChosenCity,
        flightsChosenCity: store.state.flightsChosenCity,
        accuweatherError: false
      }
    },
    methods: {
      goToNext: function() {
        store.commit('CHOOSE_FINAL', this.chosenCity);
        router.push('/result');
      },
      select: function(cityIndex) {
        this.chosenCity = cityIndex;
      }
    },
    mounted: function() {
        // 
        if ( this.weatherChosenCity == this.flightsChosenCity ) {
          this.chosenCity = this.weatherChosenCity;
          this.goToNext();
        }
        //
        Promise.all([
          this.$store.dispatch('initFlights'),
          this.$store.dispatch('initWeather')
        ]).then(() => {
          // console.log('Flights init');
        }).catch(err => {
          this.accuweatherError = true;
          console.log('ERROR', err);
        });
    },
    components: {
      mdbContainer,
      navbar,
      mdbCard, 
      mdbBtn,
      mdbRow,
      mdbCol,
      mdbCardUp, 
      mdbCardAvatar, 
      mdbCardBody, 
      mdbCardTitle, 
      mdbIcon,
      mdbInput,
      mdbModal, 
      mdbModalHeader, 
      mdbModalTitle,
      mdbModalBody, 
      mdbModalFooter,
      mdbCardImage,
      mdbCardText,
      mdbTbl,
      mdbTblBody,
      mdbTblHead
    },
  });

